import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { get } from 'lodash';

import { YardTaskCheckLocationOutcome } from '@nova/core';

import useYardTaskEvent from './useYardTaskEvent';

import type { YardTaskTimelineEvent } from '../../composables/useYardTaskTimeline';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

export default function useYardTaskCheckedEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  const { t } = useI18n();
  const baseEventData = useYardTaskEvent(event, options);

  const outcome = computed(() => get(event, 'data.data.outcome') ?? null);

  const leadIn = computed(() =>
    outcome.value === YardTaskCheckLocationOutcome.MISSING
      ? t('global.timeline.reportedAsMissing')
      : t('global.timeline.confirmedTheLocation')
  );

  const assetContainerId = computed<string | null>(
    () => get(event, 'data.data.assetContainerId') ?? null
  );

  return {
    ...baseEventData,
    outcome,
    leadIn,
    assetContainerId
  };
}
